<template>
  <ais-state-results>
    <template #default="{ state: { page }, status }">
      <div class="w-full mx-auto mt-8 md:mt-10 lg:w-auto flex justify-center">
        <primary-button
          v-if="page > 0 || status === 'idle'"
          :title="buttonTitle"
          size="large"
          class="bg-primary text-white text-14 font-montserrat"
          @click="loadMore"
        >
          {{ buttonTitle }}
          <span
            v-if="status === 'loading' || status === 'stalled'"
            class="inline-flex text-18 ml-2"
          >
            <i class="feather icon-loader animate-spin"></i>
          </span>
        </primary-button>
      </div>
    </template>
  </ais-state-results>
</template>

<script>
export default {
  name: 'JobsPagination',
  props: {
    loadMore: {
      type: Function,
      required: true,
    },
    jobsRemaining: {
      type: Number,
      required: true,
    },
  },
  computed: {
    buttonTitle() {
      return `Load ${this.jobsRemaining} More Jobs`;
    },
  },
};
</script>
